import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumIcon } from './components/icon';
import { IconContent } from './components/icon-content';

@NgModule({
  imports: [CelumIcon, IconContent, TranslatePipe],
  exports: [CelumIcon, IconContent, TranslatePipe],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class CelumIconModule {}
